import React, {useCallback} from 'react';
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector} from 'react-redux';
import {signOut} from 'aws-amplify/auth';
import {DashboardHeader, SettingItem} from '@PikaDoApp/pikado-web-dsm';
import {School} from '../graphql/API';
import {reducersState} from '../redux/reducers';

interface ReportHeaderProps {
  school: School | null;
  schoolName: string;
  studentCount: number;
  userName: string;
  notificationCount?: number;
  onMobileMenuClick: () => void;
}

export const ReportHeader: React.FC<ReportHeaderProps> = ({
  school,
  schoolName,
  studentCount,
  userName,
  notificationCount = 0,
  onMobileMenuClick,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const teacher = useSelector((state: reducersState) => state?.user?.teacher);

  // Handle logo click - navigate to home page
  const handleLogoClick = () => {
    navigate(`/school/${school?.id || ''}`);
  };

  // Resolve logo with fallback: thumbnailUri -> fileUri -> empty string
  const schoolLogoSrc = school?.promo?.thumbnailUri || school?.promo?.fileUri || '';

  // Determine if this is a school account (no teacher) or teacher account
  const isSchool = !teacher;

  // Logout logic (internal to this component)
  const handleLogout = useCallback(async () => {
    try {
      await signOut();
      await dispatch({type: 'RESET_USER'});
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  }, [dispatch, navigate]);

  const settingItems: SettingItem[] = [
    {
      label: 'Sign out',
      action: handleLogout,
    },
  ];

  return (
    <DashboardHeader
      schoolLogoSrc={schoolLogoSrc}
      schoolName={schoolName}
      studentCount={studentCount}
      userName={userName}
      notificationCount={notificationCount}
      settingItems={settingItems}
      isSchool={isSchool}
      onMobileMenuClick={onMobileMenuClick}
      onLogoClick={handleLogoClick}
    />
  );
};
